import { Helmet } from 'react-helmet-async';
import { SITE_URL, OG_IMAGE, LOCAL_BUSINESS_LD } from '../data/seo';

const abs = (p) => `${SITE_URL}${p === '/' ? '' : p}`;

// Reusable head manager: title, description, canonical, hreflang, Open Graph & JSON-LD.
const SEOHead = ({ title, description, lang = 'en', enPath, esPath, image = OG_IMAGE, jsonLd, noindex = false }) => {
  const explicitPath = lang === 'es' ? esPath || enPath : enPath;
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : undefined;
  const canonicalPath = explicitPath || currentPath;
  const canonical = !noindex && canonicalPath ? abs(canonicalPath) : undefined;
  // Every indexable page carries schema: use the page's own JSON-LD, or fall back to LocalBusiness.
  const lds = noindex ? [] : (jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [LOCAL_BUSINESS_LD]);

  return (
    <Helmet>
      <html lang={lang} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, follow" />}
      {canonical && <link rel="canonical" href={canonical} />}
      {enPath && <link rel="alternate" hrefLang="en" href={abs(enPath)} />}
      {esPath && <link rel="alternate" hrefLang="es" href={abs(esPath)} />}
      {enPath && <link rel="alternate" hrefLang="x-default" href={abs(enPath)} />}

      <meta property="og:type" content="website" />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Disc, Spine & Decompression" />
      <meta property="og:locale" content={lang === 'es' ? 'es_US' : 'en_US'} />
      <meta property="og:locale:alternate" content={lang === 'es' ? 'en_US' : 'es_US'} />
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {lds.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
};

export default SEOHead;
